import { createContext, useContext, useEffect, useState } from "react";

const CartContext = createContext(null);

export function CartProvider({ children }) {
  const [items, setItems] = useState(() => {
    try { return JSON.parse(localStorage.getItem("dk_cart") || "[]"); } catch { return []; }
  });
  const [open, setOpen] = useState(false);

  useEffect(() => {
    localStorage.setItem("dk_cart", JSON.stringify(items));
  }, [items]);

  const add = (product, qty = 1) => {
    setItems((prev) => {
      const found = prev.find((i) => i.product_id === product.id);
      if (found)
        return prev.map((i) => (i.product_id === product.id ? { ...i, qty: i.qty + qty } : i));
      return [...prev, { product_id: product.id, name: product.name, price: product.price, unit: product.unit, image: product.image, qty }];
    });
    setOpen(true);
  };

  const setQty = (product_id, qty) => {
    if (qty <= 0) return remove(product_id);
    setItems((prev) => prev.map((i) => (i.product_id === product_id ? { ...i, qty } : i)));
  };

  const remove = (product_id) => setItems((prev) => prev.filter((i) => i.product_id !== product_id));
  const clear = () => setItems([]);

  const count = items.reduce((s, i) => s + i.qty, 0);
  const total = items.reduce((s, i) => s + i.price * i.qty, 0);

  return (
    <CartContext.Provider value={{ items, add, setQty, remove, clear, count, total, open, setOpen }}>
      {children}
    </CartContext.Provider>
  );
}

export const useCart = () => useContext(CartContext);
